// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"56baae73","967":"ef17a1f4"}[chunkId] + ".chunk.js";
};